import React from 'react';

import { 
  subdomainHosts,
  subdomainUrls,
  NeuroFitCompletionSoundAsset,
  NeuroFitCompletionSoundFilepath,
  DailyInsightNotificationChannelId,
  MinCompletionSoundVolumeLevel,
  resizeInnerHeight,
  resizeInnerWidth,
  asyncCallWithTimeout,
  recordFunnelEventGA,
  HRV_MEASUREMENT_PROGRESS_25_PERCENT,
  HRV_MEASUREMENT_PROGRESS_50_PERCENT,
  HRV_MEASUREMENT_PROGRESS_75_PERCENT,
  HRV_MEASUREMENT_PROGRESS_100_PERCENT,
  lazyLoadSentryLogging,
  ProductionCertificationUrl,
  ProductionBookUrl,
  delay,
  initializeSentry,
  captureSentryException,
} from '../utils'

import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';

// import { polyfill } from "seamless-scroll-polyfill";
import smoothscroll from 'smoothscroll-polyfill';

import LandingPageContainer from '../containers/LandingPageContainer'
import CertificationPageContainer from '../containers/CertificationPageContainer'
import CertificationVideoPageContainer from '../containers/CertificationVideoPageContainer'
import CertificationVslPageContainer from '../containers/CertificationVslPageContainer'
import BookPageContainer from '../containers/BookPageContainer'
import RedirectContainer from '../containers/RedirectContainer'
import AboutPageContainer from '../containers/AboutPageContainer'
import LinksPageContainer from '../containers/LinksPageContainer'
import TrainingRegistrationPageContainer from '../containers/TrainingRegistrationPageContainer'
import ResearchPageContainer from '../containers/ResearchPageContainer'
import SupportPageContainer from '../containers/SupportPageContainer'
import BlogHomepageContainer from '../containers/BlogHomepageContainer'

import {
  commonUpdateNativeAppOpenCount,
  commonTriggerRequest,
  commonUpdatePushNotificationToken,
  commonUpdateDeepLinkedArticleKey,
  commonUpdateShowMembershipModalIfNeeded,
  commonUpdateShortcutItemType,
  commonUpdateInnerHeight,
  commonUpdateInnerWidth,
  commonUpdateSafeAreaInsets,
  commonUpdateCameraPermissions,
  commonUpdateAppActionItemType,
  commonUpdateAppStateIsActive,
  commonUpdateCurrentAppVersion,
  commonUpdateNativeCompletionSoundPreloaded,
  commonUpdateIsDeeplinkedPaywallAction,
  commonUpdateIsDeeplinkedDiscoveryQuizAction,
  commonUpdateDeepLinkedCertificationAffiliateId,
  resetCommon,
} from '../actions/common';



import {
  COMMON_APP_OPEN_STORY_SHORT_CODE,
  COMMON_NATIVE_APP_OPEN_COUNT,
} from '../constants/commonState'

import {
  triggerRequest as loggedInPageTriggerRequest,
  loggedInPageUpdateHrvCaptureState,
  loggedInPageResetHrvCaptureState,
} from '../actions/loggedInPage'

import {
  HRV_CAPTURE_STATE_STATUS,
  HRV_CAPTURE_STATE_PROGRESS,
  HRV_CAPTURE_STATE_COMPLIANCE,
  HRV_CAPTURE_STATE_DATA,
  HRV_CAPTURE_STATE_FRAME_DROP_COMPLIANCE_ERROR_COUNT,
  HRV_CAPTURE_STATE_IS_RECONFIGURING_CAMERA,
} from '../constants/hrvCaptureState'

import {
  APP_ACTION_TYPE_LEARN,
  APP_ACTION_TYPE_BALANCE,
} from '../constants/appActionTypes'

import {
  REQ_LOGIN_USER,
  REQ_FETCH_APP_CONFIG,
  REQ_FETCH_DEPLOYMENT_CONFIG,
  REQ__ACTION_AUTO_REFRESH_APP,
  REQ_VALIDATE_RESET_PASSWORD_TOKEN,
  REQ_TRIGGER_HRV_ANALYSIS_TASK,
  REQ__ACTION_UPDATE_APP_BADGE_COUNT,
  REQ__ACTION_HANDLE_APP_ACTION,
  REQ__ACTION_PRESENT_DEEPLINKED_ARTICLE,
  REQ__ACTION_HANDLE_NOTIFICATION_ACTION_TYPE,
  REQ__ACTION_PRESENT_MEMBERSHIP_MODAL,
  REQ__ACTION_PRESENT_DISCOVERY_QUIZ_MODAL,
  REQ_SAVE_NOTIFICATION_REGISTRATION_RESULT,
  REQ__ACTION_OPEN_CREATORS_URL,
  REQ__ACTION_OPEN_CERTIFICATION_URL,
  REQ__ACTION_OPEN_BOOK_URL,
  REQ__ACTION_OPEN_TRAINING_REGISTRATION_URL,
} from '../constants/requestTypes'

import {
  GA_LABEL_HRV_MEASUREMENT_TRIGGERED_HRV_MEASUREMENT,
  GA_LABEL_HRV_MEASUREMENT_HRV_MEASUREMENT_25_PERCENT,
  GA_LABEL_HRV_MEASUREMENT_HRV_MEASUREMENT_50_PERCENT,
  GA_LABEL_HRV_MEASUREMENT_HRV_MEASUREMENT_75_PERCENT,
  GA_LABEL_HRV_MEASUREMENT_HRV_MEASUREMENT_100_PERCENT,
  GA_LABEL_HRV_MEASUREMENT_HRV_MEASUREMENT_COMPLETED,
  GA_LABEL_HRV_MEASUREMENT_HRV_MEASUREMENT_ERROR,
} from '../constants/gaEventLabels'


import ErrorBoundary from '../components/ErrorBoundary'
import ForceUpgradeAppPage from '../components/ForceUpgradeAppPage'

import loadable from '@loadable/component'

const QuizAppContainer = loadable(() => import('../containers/QuizAppContainer'))

const safeAreaInsets = require('safe-area-insets')

// polyfill();

const mapStateToProps = state => ({state});

class WebsiteApp extends React.Component {

  resizeAppContainer() {
    const innerHeight = resizeInnerHeight()
    this.props.dispatch(commonUpdateInnerHeight(innerHeight))

    const innerWidth = resizeInnerWidth()
    this.props.dispatch(commonUpdateInnerWidth(innerWidth))
  }

  configureGlobalJavascriptEventListeners() {
    smoothscroll.polyfill();

    // Safe Area Insets
    safeAreaInsets.onChange(updatedValue => this.props.dispatch(commonUpdateSafeAreaInsets(safeAreaInsets)))
    this.props.dispatch(commonUpdateSafeAreaInsets(safeAreaInsets))

    window.addEventListener('resize', () => {
      this.resizeAppContainer()
    })
    
    window.addEventListener("pageshow", async () => {
      this.resizeAppContainer()
      this.props.dispatch(commonTriggerRequest(REQ_FETCH_DEPLOYMENT_CONFIG))
      this.props.dispatch(commonTriggerRequest(REQ__ACTION_AUTO_REFRESH_APP))
    })

    // Check for frontend updates whenever app is shown.
    document.addEventListener("visibilitychange", async (e) => {
      if (!document.hidden) {
        this.props.dispatch(commonTriggerRequest(REQ_FETCH_DEPLOYMENT_CONFIG))
        this.props.dispatch(commonTriggerRequest(REQ__ACTION_AUTO_REFRESH_APP))
      }
      this.resizeAppContainer()
    })
  }

  async componentWillMount() {
    try {
      // Resize the app container to fit the available size.
      this.resizeAppContainer()

      // Configure Global Window Event Listeners.
      this.configureGlobalJavascriptEventListeners()
      await initializeSentry()
    } catch (err) {
      console.error(`[INITIALIZE]: Initial Configuration Error: ${err}`)
      await initializeSentry()
      await captureSentryException(err)
    }

  }

  render() {
    return (
      <ErrorBoundary>
        <Switch>
          <Route exact path="/" component={LandingPageContainer} />
          <Route exact path="/about" component={AboutPageContainer} />
          <Route exact path="/links" component={LinksPageContainer} />
          <Route exact path="/training" component={CertificationVideoPageContainer} />
          <Route exact path="/register" component={TrainingRegistrationPageContainer} />
          <Route exact path="/vsl" component={CertificationVslPageContainer} />
          <Route exact path="/certification" component={CertificationPageContainer} />
          <Route exact path="/course" component={CertificationPageContainer} />
          <Route exact path="/learn" component={BlogHomepageContainer} />
          <Route exact path="/blog" component={BlogHomepageContainer} />
          <Route exact path="/research" component={ResearchPageContainer} />
          <Route exact path="/support" component={SupportPageContainer} />
          <Route exact path="/book" component={BookPageContainer} />
          <Route exact path="/signup" component={ForceUpgradeAppPage} />
          <Route exact path="/login" component={ForceUpgradeAppPage} />
          <Route exact path="/reset_password" component={ForceUpgradeAppPage} />
          <Route path="/reset_password/:resetPasswordToken" component={ForceUpgradeAppPage} />
          <Route exact path="/app" component={ForceUpgradeAppPage} />
          <Route exact path="/quiz" component={QuizAppContainer} />
          <Route path="/quiz/r/:quizResultKey" component={QuizAppContainer} />
          <Route render={() => <RedirectContainer redirectTo="/" />} />
        </Switch>
      </ErrorBoundary>
    );
  }
}

export default connect(mapStateToProps)(WebsiteApp);
